<div class="button-block">
    <h2 *ngIf="block.data.headerText">{{block.data.headerText}}</h2>
    <p *ngIf="block.data.buttonPreText">{{block.data.buttonPreText}}</p>
    <a [href]="block.data.documentId ? block.data.documentId : block.data.buttonLink" target="{{block.data.target}}" class="btn btn--small {{block.data.buttonType}}" role="button">{{block.data.buttonText}}</a>
</div>
